export interface CollectionHeaderEntity {

    id: number,
    draftInvoiceNo?: string | null,
    finalInvoiceNo?: string | null,
    billToCompany?: string | null,
    agentNo?: string | null,
    receiptNo?: string | null,
    subType?: string | null,
    docDate?: Date | null,
    totalAmount?: number | null,
    totalPOCash?: number | null,
    refundAmount?: number | null,
    createdBy?: string | null,
    createdDate?: Date | null,
    changedBy?: string | null,
    changedDate?: Date | null,
    isDocHdr: boolean,
    observation?: string | null,
    totalPaymentAmount?: number | null,

    [key: string]: string | boolean | number | null | Object | undefined
}

export const EMPTY_COLLECTION_HDR_ENTITY: CollectionHeaderEntity = {
    id: 0,
    draftInvoiceNo: null,
    finalInvoiceNo: null,
    billToCompany: null,
    agentNo: null,
    receiptNo: null,
    subType: null,
    docDate: null,
    totalAmount: null,
    totalPOCash: null,
    refundAmount: null,
    createdBy: null,
    createdDate: null,
    changedBy: null,
    changedDate: null,
    isDocHdr: false,
    observation: null,
    totalPaymentAmount: null,
}
